import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { Container } from "@mui/material";
import ConfigMetaPixel from "../../components/seguimiento/ConfigMetaPixel";
import { PADDING_COMO_HEADER } from "../../components/Header";

const MetaPixel = () => {
  const { id } = useParams();

  useEffect(() => {
    document.title = "Meta Pixel | PassGo";
  }, []);

  return (
    <Container maxWidth="md" sx={PADDING_COMO_HEADER}>
      <ConfigMetaPixel eventoId={id} />
    </Container>
  );
};

export default MetaPixel;
